/*
 * @Author: OP070278 zhang.cheng@opple.com
 * @Date: 2024-02-02 17:27:40
 * @LastEditors: OP070278 zhang.cheng@opple.com
 * @LastEditTime: 2024-10-29 10:58:41
 * @FilePath: /com_light2_web/src/utils/summerTimeOffset.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import store from "@/store";

function calculateDST(params, year) {
  function getSpecificSunday(year, month, weekSequence, weekDay) {
      let date = new Date(year, month - 1, 1); // 设置为该月的第一天
      let firstDay = date.getDay(); // 获取该月1日的星期几

      // 计算第一个目标星期几的日期
      let dayOffset = (weekDay - firstDay + 7) % 7; // 确保是正数
      date.setDate(1 + dayOffset);

      // 如果是第6周，意味着找到最后一个指定的星期
      if (weekSequence === 6) {
          while (date.getMonth() === month - 1) {
              date.setDate(date.getDate() + 7);
          }
          date.setDate(date.getDate() - 7);
      } else {
          date.setDate(date.getDate() + 7 * (weekSequence - 1));
      }

      return date;
  }

  const start = getSpecificSunday(year, params.InMonth, params.InWeekSequenceOfMonth, params.InWeekDay);
  start.setHours(params.InHour, params.InMinute, 0, 0);

  const end = getSpecificSunday(year, params.OutMonth, params.OutWeekSequenceOfMonth, params.OutWeekDay);
  end.setHours(params.OutHour, params.OutMinute, 0, 0);

  return { start, end };
}

function isInDST(params, date = new Date()) {
  const year = date.getFullYear();
  const { start, end } = calculateDST(params, year);
  return date >= start && date < end;
}

export default function (offset, type) {
  const summerTime = store.state.projectinfor.SummerTime;
  if ( !summerTime && !summerTime?.Enable) return false;


  // 1是其他国家的夏令时，0是欧洲夏令时
  if(summerTime.Type === 1) {
    const { EndTime, StartTime, OffsetMinute} = summerTime;
    const currentTime = new Date().getTime();
    const startTime = new Date(StartTime).getTime() + offset * 60000;
    const endTime = new Date(EndTime).getTime() + offset * 60000;
    if(currentTime >= startTime && (currentTime-OffsetMinute*60000) <= endTime) {
      offset += (type==='-'? -1 : 1) * (OffsetMinute ? OffsetMinute : 0);
    }
  }else if(summerTime.Type === 0) {
    if (isInDST(summerTime)) {
      offset += (type==='-'? -1 : 1) * (summerTime.OffsetMinute ? summerTime.OffsetMinute : 0);
    }
  
  }

 
  return offset;
}